import { Component, inject, ViewChild } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { MatIconModule } from '@angular/material/icon';

import { MatLabel } from '@angular/material/form-field';
import { MatTooltip } from '@angular/material/tooltip';
import { DialogService } from '../../../../services/dialog.service';
import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'app-formly-custom-label',
  imports: [MatIconModule, MatLabel, MatTooltip, MatIconButton],
  templateUrl: './custom-label.component.html',
  styleUrl: './custom-label.component.scss',

  standalone: true,
})
export class CustomLabelType extends FieldType<FieldTypeConfig> {
  private _dialogService = inject(DialogService);
  @ViewChild(MatTooltip) tooltip!: MatTooltip;

  openDialog() {
    this._dialogService.openDialogSimple({
      title: this.props.label,
      message: this.props['tooltip'],
    });
  }
}
